import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-credit-gauge',
  templateUrl: './icon-credit-gauge.component.html',
  styleUrls: ['./icon-credit-gauge.component.scss'],
  standalone: true,
})
export class IconCreditGaugeComponent {
  @Input() color = '#E8EEF2';
  @Input() width = '20';
  @Input() height = '20';
}
